// extracted by mini-css-extract-plugin
export default {"zoomSliderContainer":"ZoomSlider_zoomSliderContainer__n83GT","zoomText":"ZoomSlider_zoomText__SwRlg","zoomContainer":"ZoomSlider_zoomContainer__-4fuz"};